import {Component} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {
    AppAlertService,
    FormsService,
    SubtitlesService,
} from "../core";
import {UIRouter} from "@uirouter/angular";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
    forgotPasswordVisibility: boolean = true;
    externalLogin: string;
    forgotContact: string;

    constructor(
        private forms: FormsService,
        private http: HttpClient,
        private router: UIRouter,
        private $state: StateService,
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
    ) {
        this.externalLogin = this.router.globals.params['client_id'];
    }

    goLogin() {
        this.$state.go('login');
    }

    private setForgotVisibility(visible: boolean) {
        this.forgotPasswordVisibility = visible;
    }

    sendPasswordEmail() {
        const isEmailValid = this.forms.validateEmail(this.forgotContact);

        if (isEmailValid) {
            const data = {
                email: this.forgotContact,
                lang: this.subtitles.language,
            };

            this.http.post('/api/v1/account/password/reset', data).subscribe(
                (response: any) => {
                    switch (response.status) {
                        case '-2':
                            this.setForgotVisibility(false);
                            this.appAlert.showAppAlert(
                                this.subtitles.setSubtitle(1967),
                                this.subtitles.setSubtitle(1136),
                                () => this.setForgotVisibility(true),
                                false
                            );
                            break;
                        case '1':
                            this.setForgotVisibility(false);
                            this.appAlert.showAppAlert(
                                this.subtitles.setSubtitle(1966),
                                this.subtitles.setSubtitle(1129),
                                this.goLogin.bind(this),
                                false
                            );
                            break;
                    }
                }
            );
        } else {
            this.setForgotVisibility(false);
            this.appAlert.showAppAlert(
                this.subtitles.setSubtitle(1342),
                this.subtitles.setSubtitle(1136),
                () => this.setForgotVisibility(true),
                false
            );
        }
    }
}
